// API文档相关API
import request from '@/api'

// 查询文章
export async function findPage(data, num, size) {
  return request({
    url: `/capi/community/article/findPage?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
// 查询收藏列表
export async function findTarget(data, num, size) {
  return request({
    url: `/capi/community/collection/findTarget?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}

// 查询频道
export async function channelFindAll(data) {
  return request({
    url: '/capi/community/channel/findAll',
    method: 'post',
    data
  })
}

export async function collection(data) {
  return request({
    url: `/capi/community/collection`,
    method: 'post',
    data
  })
}
export async function findPageSuperior(data, num, size) {
  return request({
    url: `/capi/community/comment/findPageSuperior?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}

export async function commentFindPage(data, num, size) {
  return request({
    url: `/capi/community/comment/findPage?pageNum=${num}&pageSize=${size}`,
    method: 'post',
    data
  })
}
